// HeroSection.jsx
import React from 'react';
import './HeroSection.css';
import { Button } from './ui/button.js';
import { ArrowRight, Shield, Zap, Clock } from 'lucide-react';
import { mockCompanyData, mockStats } from './mock';

const HeroSection = () => {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-container">
        <div className="hero-grid">
          {/* Left Content */}
          <div className="hero-left">
            <div className="badge">
              <Shield className="icon-small" />
              Trusted by 2,500+ Businesses
            </div>
            <h1 className="hero-title">
              {mockCompanyData.name.split(' ')[0]}
              <span className="highlighted-text">
                {' ' + mockCompanyData.name.split(' ').slice(1).join(' ')}
              </span>
            </h1>
            <p className="hero-description">
              {mockCompanyData.description}
            </p>

            {/* Feature Pills */}
            <div className="features">
              <div className="feature-pill">
                <Zap className="icon-small text-emerald" />
                <span>15min Response</span>
              </div>
              <div className="feature-pill">
                <Clock className="icon-small text-emerald" />
                <span>24/7 Support</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="hero-cta">
              <Button onClick={scrollToContact} size="lg" className="cta-primary">
                Get Support Now
                <ArrowRight className="icon-small ml" />
              </Button>
              <Button onClick={scrollToServices} size="lg" variant="outline" className="cta-secondary">
                View Services
              </Button>
            </div>

            {/* Stats */}
            <div className="stats-grid">
              {mockStats.map((stat, index) => (
                <div key={index} className="stat">
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content */}
          <div className="hero-right">
            <div className="tech-illustration">
              <div className="main-icon">
                <Shield className="icon-large white" />
              </div>

              {/* Floating Cards */}
              <div className="floating-card top-right bounce">
                <div className="dot" />
              </div>
              <div className="floating-card bottom-left bounce delay-1">
                <Zap className="icon-medium text-emerald" />
              </div>
              <div className="floating-card top-left bounce delay-2">
                <Clock className="icon-small text-emerald" />
              </div>

              {/* Background Circles */}
              <div className="circle ping circle-1" />
              <div className="circle ping delay-1 circle-2" />
              <div className="circle ping delay-2 circle-3" />
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Backgrounds */}
      <div className="bg-decoration top-right" />
      <div className="bg-decoration bottom-left" />
    </section>
  );
};

export default HeroSection;
